<template>
  <v-container fluid>
    <v-data-table
      :options.sync="options"
      :footer-props="{ itemsPerPageOptions: [10, 25, 50, -1] }"
      :headers="computedHeders"
      :items="exports"
      :single-expand="true"
    >
      <template v-slot:top>
        <v-toolbar
            class="mt-4"
            flat
        >
          <v-btn
              icon
              outlined
              @click="refreshData"
          >
            <v-tooltip
                bottom
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                    v-bind="attrs"
                    v-on="on"
                    color="primary"
                >
                  mdi-refresh
                </v-icon>
              </template>
              refresh exports list
            </v-tooltip>
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:item.user="{ item }">
          {{ `${item.user_name} (ID: ${item.user_id})` }}
      </template>

      <template v-slot:item.uri="{ item }">
        <span
            v-if="item.uri"
            @click="download(item.id)"
            class="uri"
        >
          {{ item.uri }}
        </span>
      </template>

      <template v-slot:item.error="{ item }">
        {{ hasAnyAbility($constants.ABILITY.CUSTOMER) ? item.public_error : item.error }}
      </template>

      <template v-slot:item.is_use_upload_date="{ item }">
        {{ item.is_use_upload_date ? 'true' : 'false' }}
      </template>

      <template v-slot:item.created_at="{ item }">
        {{ formattedDate(item.created_at) }}
      </template>

      <template v-slot:item.updated_at="{ item }">
        {{ formattedDate(item.updated_at) }}
      </template>

      <template v-slot:item.actions="{ item }">
        <v-btn
            v-if="!hasAnyAbility($constants.ABILITY.CUSTOMER)"
            icon
            @click="remove(item.id)"
            :disabled="!['error','complete'].includes(item.status)"
        >
          <v-icon
              color="red"
          >
            mdi-delete
          </v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'Exports',

  data: () => ({
    itemClone: {},
    exports: [],

    headers: [
      { text: 'id', value: 'id' },
      { text: 'uuid', value: 'uuid' },
      { text: 'user', value: 'user', is_private: true },
      { text: 'composite customer name', value: 'composite_customer_name' },
      { text: 'timestamp begin', value: 'timestamp_begin' },
      { text: 'timestamp end', value: 'timestamp_end' },
      { text: 'use upload time', value: 'is_use_upload_date' },
      { text: 'status', value: 'status' },
      { text: 'stage', value: 'stage' },
      { text: 'uri', value: 'uri' },
      { text: 'started at', value: 'created_at' },
      { text: 'updated at', value: 'updated_at' },
      { text: 'error', value: 'error' },
      { text: 'public_error', value: 'public_error', is_private: true },
      { text: '', value: 'actions' },
    ],
    options: {
      itemsPerPage: 10,
      sortBy: ['id'],
      sortDesc: [false],
      mustSort: true,
      multiSort: false,
    },

  }),

  created() {
    this.fetchData();
  },

  methods: {
    ...mapActions({
      setSnack: 'snackbar/setState',
    }),

    async fetchData() {
      await this.$requestHelpers
        .get('api/admin/exports')
        .then((response) => {
          this.exports = response.data;
        }).catch((error) => {
          if (error.response) {
            if (error.response.status === 403) {
              this.$router.push({ name: 'root' });
            }
          }
        });
    },

    async refreshData() {
      await this.fetchData();
    },

    download(id) {
      this.$requestHelpers
        .post(
          'api/admin/exportDownload',
          {
            id,
          },
          {
            responseType: 'blob',
          },
        )
        .then((response) => {
          const contentType = response.headers['content-type'];

          if (contentType.includes('application/json')) {
            const reader = new FileReader();
            reader.onload = () => {
              const json = JSON.parse(reader.result);

              this.setSnack({
                snack: true,
                color: json.status === 'error' ? 'red' : 'orange',
                text: json.message,
              });
            };
            reader.readAsText(response.data);
          } else {
            const fileURL = window.URL.createObjectURL(new Blob([response.data]));
            const fileLink = document.createElement('a');
            const headerval = response.headers['content-disposition'];
            const filename = headerval.match(/filename=(.*)/);

            fileLink.href = fileURL;
            fileLink.setAttribute('download', filename[1]);
            document.body.appendChild(fileLink);

            fileLink.click();
          }
        })
        .catch((error) => {
          const reader = new FileReader();
          reader.onload = () => {
            const json = JSON.parse(reader.result);

            this.setSnack({
              snack: true,
              color: 'red',
              text: json.message,
            });
          };
          reader.readAsText(error.response.data);
        });
    },

    remove(id) {
      this.$confirm(`Are you sure you want to delete that export (ID: ${id})?`).then((res) => {
        if (!res) return;

        this.$requestHelpers
          .delete(`api/admin/export/${id}`)
          .then((response) => {
            if (response.data.success) {
              this.setSnack({
                color: 'green',
                text: 'deleted',
              });
              this.exports = this.exports.filter((e) => e.id !== id);
            } else {
              this.setSnack({
                color: 'red',
                text: 'error',
              });
            }
          });
      });
    },

    formattedDate(date) {
      const dateObj = new Date(date);

      return dateObj.toISOString().replace('T', ' ').split('.')[0];
    },
  },
  computed: {
    computedHeders() {
      if (this.hasAnyAbility(this.$constants.ABILITY.CUSTOMER)) {
        return this.headers.filter((el) => el.is_private === undefined || el.is_private === false);
      }

      return this.headers;
    },
  },
};
</script>

<style scoped>
.uri {
  cursor: pointer;
  text-decoration: underline;
  color: blue;
}

.uri:hover {
  text-decoration: none;
}

</style>
